import React, { ReactNode } from 'react'
import { Lock01Icon } from '@systemeio/icons'
import { twMerge } from 'tailwind-merge'
import { useMediaQuery } from 'shared/hooks/use-match-media'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'

interface CourseLoginOrPurchaseScreenProps {
  text: ReactNode
  icon?: ReactNode
  buttons?: ReactNode
  className?: string
}

export const CourseInfoScreenLayout = ({
  className,
  icon = (
    <div className="rounded-full bg-THEME-disabled p-5">
      <Lock01Icon className="size-10 text-THEME-background" />
    </div>
  ),
  text,
  buttons,
}: React.PropsWithChildren<CourseLoginOrPurchaseScreenProps>): ReactNode => {
  const isLG = useMediaQuery('(min-width: 1024px)', false)

  const publicCustomClassNamePrefix = addPublicCustomClassNamePrefix('course__info-screen')

  return (
    <div className={twMerge('basis-full', className, publicCustomClassNamePrefix)}>
      <div
        className={twMerge(
          `mt-10 flex w-full flex-col items-center justify-center lg:mt-0`,
          className,
        )}
        style={{ transform: isLG ? 'translateY(min(100vh, 50vh - 100%))' : '' }}
      >
        {icon}
        <p className="mt-5 text-center text-base font-semibold text-THEME-primary lg:text-xl">
          {text}
        </p>
        <div className="mt-7 flex w-full flex-wrap justify-center gap-3">{buttons}</div>
      </div>
    </div>
  )
}
